<template>
    <b-modal ref="mdlEditTipoPrestazione" id="mdlEditTipoPrestazione" :title="title" size="lg" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Nome</label>
                <b-form-input v-model="jsonDataTipoPrestazione.nome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Prestazione</label>
                <b-form-input v-model="jsonDataTipoPrestazione.codicePrestazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Regime</label>
                <b-form-select v-model="jsonDataTipoPrestazione.regime" :options="regimiOptions" :value="''" value-field="codice" text-field="descrizione">
                    <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona Regime -</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Importo</label>
                <b-form-input v-model="jsonDataTipoPrestazione.importo"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Quota ASL(%)</label>
                <b-form-input class="sa-form-label" v-model="jsonDataTipoPrestazione.percentualeAsl" @blur="onBlurPercentualeAsl" type="number" step="0.01"> </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Quota ASL(€)</label>
                <b-form-input v-model="jsonDataTipoPrestazione.quotaAsl" @blur="onBlurQuotaAsl"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonDataTipoPrestazione.note" rows="7" max-rows="8"> </b-form-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button @click="onCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button @click="onSaveTipoPrestazione" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    name: "RsaConfigurazioneTipoPrestazioneEdit",
    components: { ModalError },
    mixins: [UtilityMixin],
    data() {
        return {
            title: null,
            pathResource: "/rsatipoprestazioni",
            pathResourceRegimi: "/rsatipoprestazioniregimi",
            regimiOptions: [],
            jsonDataTipoPrestazione: {
                id: null,
                nome: null,
                importo: 0,
                percentualeAsl: null,
                quotaAsl: 0,
                quotaComune: 0,
                quotaUtente: 0,
                note: null,
                codicePrestazione: null,
                regime: null,
                statoAttuale: null,
                statoAttualeDataOra: null,
            },
        };
    },
    methods: {
        show(jsonData) {
            let me = this;
            me.jsonDataTipoPrestazione = jsonData;
            if (!me.jsonDataTipoPrestazione.id) {
                me.jsonDataTipoPrestazione.statoAttuale = "ATTIVA";
                me.jsonDataTipoPrestazione.statoAttualeDataOra = new Date().getTime();
            }
            me.title = !jsonData.id ? "Nuova Prestazione" : "Aggiorna Prestazione";
            me.loadTipoPrestazioneRegime();
            me.$refs.mdlEditTipoPrestazione.show();
        },
        loadTipoPrestazioneRegime() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceRegimi, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.regimiOptions = response.data.data.list;
        },
        loadDataError(response) {
            console.log(response);
        },
        onCloseModal() {
            let me = this;
            me.jsonDataTipoPrestazione = {};
            me.$refs.mdlEditTipoPrestazione.hide();
            me.$emit("onClose");
        },
        onSaveTipoPrestazione() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataTipoPrestazione, me.saveTipoPrestazioneSuccess, me.saveTipoPrestazioneError);
        },
        saveTipoPrestazioneSuccess(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlEditTipoPrestazione.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveTipoPrestazioneError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        /* if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                this.$bvToast.toast("Errore nel salvataggio" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            } */
        deletePrestazione(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteTipoPrestazioneSuccess, me.deleteTipoPrestazioneError);
        },
        deleteTipoPrestazioneSuccess(response) {
            let me = this;
            me.$emit("deletePrestazione", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteTipoPrestazioneError(response) {
            let me = this;
            me.$emit("deletePrestazione", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore,",
                variant: "danger",
                solid: true,
            });
        },
        onDeletePrestazione(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di voler eliminare questa prestazione?", {
                    title: "Eliminazione prestazione",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deletePrestazione(item.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onBlurPercentualeAsl() {
            let quotaAsl = (this.jsonDataTipoPrestazione.importo * this.jsonDataTipoPrestazione.percentualeAsl) / 100;
            this.jsonDataTipoPrestazione.quotaAsl = quotaAsl.toFixed(3);
        },
        onBlurQuotaAsl() {
            let percentualeAsl = (this.jsonDataTipoPrestazione.quotaAsl * 100) / this.jsonDataTipoPrestazione.importo;
            this.jsonDataTipoPrestazione.percentualeAsl = percentualeAsl.toFixed(3);
        },
    },
};
</script>
